var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownvoteActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9003 10.566C20.8185 10.3965 20.6906 10.2535 20.5312 10.1534C20.3719 10.0533 20.1875 10.0001 19.9993 10H15.9993V3C15.9993 2.73478 15.8939 2.48043 15.7064 2.29289C15.5189 2.10536 15.2645 2 14.9993 2H8.9993C8.73408 2 8.47973 2.10536 8.29219 2.29289C8.10466 2.48043 7.9993 2.73478 7.9993 3V10H3.9993C3.81103 10.0003 3.62667 10.0537 3.46739 10.1541C3.3081 10.2545 3.18035 10.3977 3.09879 10.5674C3.01724 10.7371 2.98519 10.9263 3.00633 11.1134C3.02747 11.3005 3.10094 11.4778 3.2183 11.625L11.2183 21.625C11.312 21.7422 11.4308 21.8367 11.566 21.9017C11.7012 21.9667 11.8493 22.0005 11.9993 22.0005C12.1493 22.0005 12.2974 21.9667 12.4326 21.9017C12.5678 21.8367 12.6866 21.7422 12.7803 21.625L20.7803 11.625C21.0203 11.324 21.0663 10.913 20.9003 10.566Z",
    fill: "#FF5B5B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownvoteActive);
export default __webpack_public_path__ + "static/media/downvote-active.b053950d654126aed9b154ce399fe827.svg";
export { ForwardRef as ReactComponent };